export const environment = {
    production: true,
    mapBoxToken:
        'pk.eyJ1IjoiY2VuZXJnb24iLCJhIjoiY2sxNG50MzF3MG1hMTNwdGtyY3A5MndmaCJ9.aEYmriTt0i7zYEV6nQVeTA',
    urlBackend: 'https://signomedico.cipbyte.io/api/',
    urlOpenBlank: 'https://signomedico.cipbyte.io/web/#/',
    urlOpenPagesHtml: 'https://signomedico.cipbyte.io/web/assets/pages-html/',
    version: "v5.3.4",
    googleClientId:
        '880140909688-2si79psn659q6qp63e2l94eck51jonrq.apps.googleusercontent.com',
    redirectUri: 'https://signomedico.cipbyte.io/api/auth/google/callback',
    enableGoogleLogin : true,
    modoAdmin: false,
};
